import {fork, select, take} from 'redux-saga/effects';
import {closeModal, openModal} from '@computerrock/formation-router/sagas';
import {QualityManagementFeedback} from '@ace-de/eua-entity-types';
import fetchRequest from '../../application/sagas/fetchRequest';
import modalIds from '../../modalIds';
import * as contractPartnerActionTypes from '../contractPartnerActionTypes';

const createQualityReportFlow = function* createQualityReportFlow() {
    const {serviceManager} = yield select(state => state.application);
    const partnerManagementService = serviceManager.loadService('partnerManagementService');

    while (true) {
        const {payload} = yield take(
            contractPartnerActionTypes.INITIATE_CREATE_CONTRACT_PARTNER_QUALITY_REPORT_FLOW,
        );
        const {serviceCaseId, contractPartnerName, contractPartnerId} = payload || {};

        yield* openModal(
            modalIds.CP_CREATE_QUALITY_REPORT,
            serviceCaseId && contractPartnerName && contractPartnerId
                ? {
                    serviceCaseId: `${serviceCaseId}`,
                    contractPartnerId: `${contractPartnerId}`,
                    contractPartnerName: `${contractPartnerName}`,
                } : undefined,
        );

        const chosenModalOption = yield take([
            contractPartnerActionTypes.DECLINE_CREATE_CONTRACT_PARTNER_QUALITY_REPORT,
            contractPartnerActionTypes.CONFIRM_CREATE_CONTRACT_PARTNER_QUALITY_REPORT,
        ]);

        if (chosenModalOption.type === contractPartnerActionTypes.DECLINE_CREATE_CONTRACT_PARTNER_QUALITY_REPORT) {
            yield* closeModal(
                modalIds.CP_CREATE_QUALITY_REPORT,
                serviceCaseId && contractPartnerName && contractPartnerId
                    ? {
                        serviceCaseId: `${serviceCaseId}`,
                        contractPartnerId: `${contractPartnerId}`,
                        contractPartnerName: `${contractPartnerName}`,
                    } : undefined,
            );
            continue;
        }

        const {qualityReportData} = chosenModalOption.payload;

        yield fork(
            fetchRequest,
            contractPartnerActionTypes.CREATE_CONTRACT_PARTNER_QUALITY_REPORT_REQUEST,
            partnerManagementService.createContractPartnerQualityReport,
            {
                qualityReportData: QualityManagementFeedback.objectToDTO(qualityReportData),
            },
        );

        const responseAction = yield take([
            contractPartnerActionTypes.CREATE_CONTRACT_PARTNER_QUALITY_REPORT_REQUEST_SUCCEEDED,
            contractPartnerActionTypes.CREATE_CONTRACT_PARTNER_QUALITY_REPORT_REQUEST_FAILED,
        ]);

        // NOTE: errors are handled implicitly as part of the fetchRequest
        // below you can handle something in addition if needed

        yield* closeModal(
            modalIds.CP_CREATE_QUALITY_REPORT,
            serviceCaseId && contractPartnerName && contractPartnerId
                ? {
                    serviceCaseId: `${serviceCaseId}`,
                    contractPartnerId: `${contractPartnerId}`,
                    contractPartnerName: `${contractPartnerName}`,
                } : undefined,
        );

        /* eslint-disable-next-line max-len */
        if (responseAction.type === contractPartnerActionTypes.CREATE_CONTRACT_PARTNER_QUALITY_REPORT_REQUEST_SUCCEEDED) {
            yield* openModal(modalIds.CP_QUALITY_MANAGEMENT_NOTE_SUCCESSFUL);
        }
    }
};

export default createQualityReportFlow;
